
const $2b6e161c9edcf319$var$modal = document.querySelector(".modal");
const $2b6e161c9edcf319$var$btn = document.querySelector(".rules-btn");
const $2b6e161c9edcf319$var$span = document.querySelector(".close");
const $2b6e161c9edcf319$var$buttonEl = document.querySelectorAll(".circle");
const $2b6e161c9edcf319$var$winner = document.querySelector(".display-winner");
const $2b6e161c9edcf319$var$reset = document.querySelector(".reset");
const $2b6e161c9edcf319$var$computerPoints = document.querySelector(".computer-points");
const $2b6e161c9edcf319$var$playerPoints = document.querySelector(".player-points");
let $2b6e161c9edcf319$var$playerCount = 0;
let $2b6e161c9edcf319$var$computerCount = 0;
$2b6e161c9edcf319$var$btn.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$modal.style.display = "block";
});
$2b6e161c9edcf319$var$span.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$modal.style.display = "none";
});
window.addEventListener("click", (e)=>{
    if (e.target === $2b6e161c9edcf319$var$modal) $2b6e161c9edcf319$var$modal.style.display = "none";
});
$2b6e161c9edcf319$var$buttonEl.forEach((button)=>{
    button.addEventListener("click", ()=>{
        $2b6e161c9edcf319$var$winner.style.display = "block";
        let userChoice = button.value;
        const options = [
            "Rock",
            "Paper",
            "Scissor",
            "Lizard",
            "Spock"
        ];
        const computerChoice = options[Math.floor(Math.random() * options.length)];
        if (computerChoice === userChoice) $2b6e161c9edcf319$var$winner.textContent = `Tie`;
        else if (userChoice === "rock" && computerChoice === "Lizard" || userChoice === "rock" && computerChoice === "Scissor" || userChoice === "paper" && computerChoice === "Rock" || userChoice === "paper" && computerChoice === "Spock" || userChoice === "scissor" && computerChoice === "Paper" || userChoice === "scissor" && computerChoice === "Lizard" || userChoice === "lizard" && computerChoice === "Paper" || userChoice === "lizard" && computerChoice === "Spock" || userChoice === "spock" && computerChoice === "Scissor" || userChoice === "spock" && computerChoice === "Rock") {
            $2b6e161c9edcf319$var$winner.textContent = `Computer played : ${computerChoice}, Player Wins`;
            $2b6e161c9edcf319$var$playerCount += 1;
            $2b6e161c9edcf319$var$playerPoints.value = $2b6e161c9edcf319$var$playerCount;
        } else {
            $2b6e161c9edcf319$var$winner.textContent = `Computer Wins`;
            $2b6e161c9edcf319$var$computerCount += 1;
            $2b6e161c9edcf319$var$computerPoints.value = $2b6e161c9edcf319$var$computerCount;
        }
    });
});
$2b6e161c9edcf319$var$reset.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$computerPoints.value = "";
    $2b6e161c9edcf319$var$playerPoints.value = "";
    $2b6e161c9edcf319$var$winner.style.display = "none";
    $2b6e161c9edcf319$var$playerCount = 0;
    $2b6e161c9edcf319$var$computerCount = 0;
});


//# sourceMappingURL=index.ab7cc9a9.js.map
